import React from "react";
import PropTypes from "prop-types";
import { Card, Col } from "react-bootstrap";
import { ExternalLink } from "react-feather";

export default function SingleCard({
  imgUrl,
  imgAlt,
  date,
  noLink,
  url,
  externalLink,
  title,
  lead,
  children,
}) {
  return (
    <Col sm={6} lg={4} className="d-flex align-items-stretch">
      <Card className="mb-4 border-secondary w-100">
        {imgUrl && <Card.Img variant="top" alt={imgAlt} src={imgUrl} />}
        <Card.Body>
          {date && <small className="text-muted">{date}</small>}
          <Card.Title className="mb-3">
            {!noLink && (
              <Card.Link href={url} className="link link-bold font-weight-bold">
                {title}
              </Card.Link>
            )}
            {externalLink && !noLink && (
              <ExternalLink className="ml-1" size="19" strokeWidth="2" />
            )}
            {noLink && (
              <h3 className="font-weight-bold card-link h4">{title}</h3>
            )}
          </Card.Title>
          {lead && <Card.Text>{lead}</Card.Text>}
          {children}
        </Card.Body>
      </Card>
    </Col>
  );
}

SingleCard.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  externalLink: PropTypes.bool,
  noLink: PropTypes.bool,
  lead: PropTypes.string,
  imgUrl: PropTypes.string,
  imgAlt: PropTypes.string,
  date: PropTypes.string,
};

SingleCard.defaultProps = {
  title: "Overskrift",
  url: "/",
  externalLink: false,
  imgAlt: "",
};
